import { PHONE, locationSchema } from "../structured-data-core";

export function getCincinnatiStructuredData() {
  const url = "https://restorehair.com/locations/ohio/cincinnati/";
  const description =
    "Find out about your hair transplant options in Cincinnati with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Cincinnati", "300 E. Business Way, Suite 200", "Cincinnati", "OH", PHONE, url, description),
  ];
}
